angular.module('unergie.main')
.factory('GraphGeneratorService', () => {
    const createGroupedGraph = function (id, data) {
        if (data && (data.length > 0)) {
            d3.selectAll(id).select('svg').remove()
            const svg = d3.select(id).append('svg')
            const margin = { top: 20, right: 20, bottom: 30, left: 40 }
            const bounds = d3.selectAll(id).node().getBoundingClientRect()
            const width = bounds.width - margin.left - margin.right
            const height = bounds.height - margin.top - margin.bottom
            const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

            const x0 = d3.scaleBand().rangeRound([0, width]).padding(0.1)
            const x1 = d3.scaleBand().rangeRound([0, width]).padding(0.05)
            const y = d3.scaleLinear().rangeRound([height, 0])
            const z = d3.scaleOrdinal().range(['#26b99a', '#34495e', '#acadac', '#3498db', '#B6599B', '#f0ad4e', '#d9534f'])


            const keys = Object.keys(data[0].values)

            x0.domain(data.map((d) => d.name))
            x1.domain(keys).rangeRound([0, x0.bandwidth()])
            const max = d3.max(data, (d) => d3.max(keys, (key) => d.values[key]))
            y.domain([0, max]).nice()

            const tip = d3.tip()
            .attr('class', 'd3-tip')
            .offset([-10, 0])
            .html((d) => `<strong>${d.key}:</strong> <span><b>${d.value}</b></span>`)

            g.call(tip)

            g.append('g')
            .selectAll('g')
            .data(data)
            .enter().append('g')
            .attr('transform', (d) => `translate(${x0(d.name)},0)`)
            .selectAll('rect')
            .data((d) => keys.map((key) => ({ key, value: (d.values[key] || 0) })))
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('ry', 2)
            .attr('x', (d) => x1(d.key))
            .attr('y', (d) => y(d.value))
            .attr('width', x1.bandwidth())
            .attr('height', (d) => height - y(d.value))
            .attr('fill', (d) => z(d.key))
            .on('mouseover', tip.show)
            .on('mouseout', tip.hide)

            g.append('g')
            .attr('class', 'axis')
            .attr('font-size', 15)
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x0))

            g.append('g')
            .attr('class', 'axis y')
            .call(d3.axisLeft(y).ticks(null, 's'))
            .append('text')
            .attr('x', 2)
            .attr('y', y(y.ticks().pop()) + 0.5)
            .attr('dy', '0.32em')
            .attr('fill', '#000')
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'start')

            const legend = g.append('g')
            .attr('font-family', 'sans-serif')
            .attr('font-size', 10)
            .attr('text-anchor', 'end')
            .selectAll('g')
            .data(keys.slice().reverse())
            .enter().append('g')
            .attr('transform', (d, i) => `translate(0,${i * 20})`)

            legend.append('rect')
            .attr('x', width - 19)
            .attr('width', 19)
            .attr('height', 19)
            .attr('fill', z)

            return legend.append('text')
            .attr('x', width - 24)
            .attr('y', 9.5)
            .attr('dy', '0.32em')
            .text((d) => d)
        }
    }

    const createStackedGraph = function (id, data) {
        if (data && (data.length > 0)) {
            d3.selectAll(id).select('svg').remove()
            const svg = d3.select(id).append('svg')
            const margin = { top: 20, right: 20, bottom: 30, left: 40 }
            const bounds = d3.selectAll(id).node().getBoundingClientRect()
            const width = bounds.width - margin.left - margin.right
            const height = bounds.height - margin.top - margin.bottom
            const g = svg.append('g').attr('transform', `translate(${margin.left},${margin.top})`)

            const x = d3.scaleBand().rangeRound([0, width]).padding(1)
            const y = d3.scaleLinear().rangeRound([height, 0])
            const z = d3.scaleOrdinal().range(['#26b99a', '#34495e', '#acadac', '#3498db', '#B6599B', '#f0ad4e', '#d9534f'])

            const keys = Object.keys(data[0].values)

            x.domain(data.map((d) => d.name))
            y.domain([0, 100]).nice()

            const tip = d3.tip()
            .attr('class', 'd3-tip')
            .offset([-10, 0])
            .html((d) => `<strong>${d.key}:</strong> <span><b>${d.percent.toFixed(2)}% (${d.value})</b></span>`)

            g.call(tip)

            const barWidth = width / (data.length + 2)

            const dataTransformed = []
            data.forEach((d) => {
                d.total = 0
                return keys.forEach((key) => (d.total += d.values[key] || 0))
            })

            data.forEach((d) => {
                let yOffset = 0
                return keys.forEach((key) => {
                    const value = (d.values[key] || 0)
                    const percent = ((100 * value) / d.total)
                    dataTransformed.push({ name: d.name, key, value, percent, yOffset })
                    return (yOffset += percent)
                })
            })

            g.append('g')
            .selectAll('g')
            .data(dataTransformed)
            .enter().append('rect')
            .attr('class', 'bar')
            .attr('x', (d) => x(d.name) - (barWidth / 2))
            .attr('y', (d) => y(d.percent + d.yOffset))
            .attr('width', barWidth)
            .attr('height', (d) => height - y(d.percent))
            .attr('fill', (d) => z(d.key))
            .on('mouseover', tip.show)
            .on('mouseout', tip.hide)

            g.append('g')
            .attr('class', 'axis')
            .attr('font-size', 15)
            .attr('transform', `translate(0,${height})`)
            .call(d3.axisBottom(x))

            g.append('g')
            .attr('class', 'axis y')
            .call(d3.axisLeft(y).ticks(null, 's'))
            .append('text')
            .attr('x', 2)
            .attr('y', y(y.ticks().pop()) + 0.5)
            .attr('dy', '0.32em')
            .attr('fill', '#000')
            .attr('font-weight', 'bold')
            .attr('text-anchor', 'start')

            const legend = g.append('g')
            .attr('font-family', 'sans-serif')
            .attr('font-size', 10)
            .attr('text-anchor', 'end')
            .selectAll('g')
            .data(keys.slice().reverse())
            .enter().append('g')
            .attr('transform', (d, i) => `translate(0,${i * 20})`)

            legend.append('rect')
            .attr('x', width - 19)
            .attr('width', 19)
            .attr('height', 19)
            .attr('fill', z)

            return legend.append('text')
            .attr('x', width - 24)
            .attr('y', 9.5)
            .attr('dy', '0.32em')
            .text((d) => d)
        }
    }

    return {
        createGroupedGraph,
        createStackedGraph,
    }
})
